import React from 'react';
import Step from "./Step";
import Strings from "../Lang/strings";

const Stepper = ({currentStep, stepsLang, steps}) => {
    return (
        <div className="flex items-center">
            {
                steps.map((step, index) => <Step
                        circleContent={step.order}
                        prev={currentStep > index}
                        active={currentStep === index}
                        key={index}
                        label={Strings.getString(step.label)}
                    />
                )
            }
        </div>
    );
};

export default React.memo(Stepper);
// export default Stepper;
